import React from "react";
import { Handle, Position } from "react-flow-renderer";
import { LockOutlined } from "@ant-design/icons";
import { iconoDeEtapa, colorDeEtapa } from "./etapaVisual.utils";
import { LADOS_CONECTOR } from "./diagramaEtapas.utils";

const ANCHO_ROMBO = 190;
const ALTO_ROMBO = 120;
const DIAMETRO_CIRCULO = 120;

const POSICION_LADO = { top: Position.Top, right: Position.Right, bottom: Position.Bottom, left: Position.Left };

const ContenidoEtapa = ({ etapa, color, deshabilitada }) => (
  <>
    <div style={{ fontSize: 20, color, marginBottom: 4 }}>{iconoDeEtapa(etapa)}</div>
    <div style={{ fontWeight: 600, fontSize: 13 }}>
      {etapa.nombre} {etapa.protegida && <LockOutlined style={{ fontSize: 10, color: "#8c8c8c" }} />}
    </div>
    {deshabilitada && <div style={{ fontSize: 10, color: "#ff4d4f" }}>Deshabilitada</div>}
  </>
);

const estiloConector = (lado, tipo, esRombo) => {
  const horizontal = lado === "top" || lado === "bottom";
  const desplazamiento = esRombo ? (tipo === "target" ? "44%" : "56%") : tipo === "target" ? "35%" : "65%";
  const hundimiento = esRombo ? (horizontal ? 7 : 11) : undefined;
  return horizontal
    ? { left: desplazamiento, ...(hundimiento !== undefined && { [lado]: hundimiento }) }
    : { top: desplazamiento, ...(hundimiento !== undefined && { [lado]: hundimiento }) };
};

const NodoEtapaFlow = ({ data, selected }) => {
  const { etapa, forma, conectoresEnUso, editando } = data;
  const color = colorDeEtapa(etapa);
  const deshabilitada = etapa.estado !== 1;
  const esRombo = forma === "rombo";
  const esCirculo = forma === "inicio" || forma === "fin";

  const handles = LADOS_CONECTOR.flatMap((lado) =>
    ["target", "source"].map((tipo) => {
      const id = `${lado}-${tipo}`;
      const visible = editando || conectoresEnUso?.has(id);
      return (
        <Handle
          key={id}
          id={id}
          type={tipo}
          position={POSICION_LADO[lado]}
          isConnectable={!!editando}
          style={{
            background: color,
            width: editando ? 10 : 8,
            height: editando ? 10 : 8,
            opacity: visible ? 1 : 0,
            border: tipo === "target" ? "2px solid white" : undefined,
            ...estiloConector(lado, tipo, esRombo),
          }}
        />
      );
    })
  );

  if (esCirculo) {
    return (
      <div
        style={{
          position: "relative",
          width: DIAMETRO_CIRCULO,
          height: DIAMETRO_CIRCULO,
          borderRadius: "50%",
          background: "white",
          border: `${forma === "fin" ? 5 : 2}px solid ${color}`,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: 14,
          boxShadow: selected ? "0 0 0 3px rgba(24,144,255,0.35)" : "0 2px 6px rgba(0,0,0,0.08)",
          opacity: deshabilitada ? 0.5 : 1,
        }}
      >
        <ContenidoEtapa etapa={etapa} color={color} deshabilitada={deshabilitada} />
        {handles}
      </div>
    );
  }

  if (esRombo) {
    return (
      <div style={{ position: "relative", width: ANCHO_ROMBO, height: ALTO_ROMBO, opacity: deshabilitada ? 0.5 : 1 }}>
        <svg width={ANCHO_ROMBO} height={ALTO_ROMBO} style={{ position: "absolute", top: 0, left: 0, overflow: "visible" }}>
          <polygon
            points={`${ANCHO_ROMBO / 2},1 ${ANCHO_ROMBO - 1},${ALTO_ROMBO / 2} ${ANCHO_ROMBO / 2},${ALTO_ROMBO - 1} 1,${ALTO_ROMBO / 2}`}
            fill="white"
            stroke={color}
            strokeWidth={2}
            style={{ filter: selected ? "drop-shadow(0 0 4px #1890ff)" : "drop-shadow(0 2px 3px rgba(0,0,0,0.12))" }}
          />
        </svg>
        <div
          style={{
            position: "absolute",
            inset: "22px 40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <ContenidoEtapa etapa={etapa} color={color} deshabilitada={deshabilitada} />
        </div>
        {handles}
      </div>
    );
  }

  return (
    <div
      style={{
        background: "white",
        border: `2px solid ${color}`,
        borderRadius: 10,
        padding: "10px 16px",
        minWidth: 160,
        textAlign: "center",
        boxShadow: selected ? "0 0 0 3px rgba(24,144,255,0.35)" : "0 2px 6px rgba(0,0,0,0.08)",
        opacity: deshabilitada ? 0.5 : 1,
      }}
    >
      <ContenidoEtapa etapa={etapa} color={color} deshabilitada={deshabilitada} />
      {handles}
    </div>
  );
};

export default NodoEtapaFlow;
